import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
// Constants - Functions
import { WEB_SERVICE_MIMS } from "../../../../../../config/constants";
// Components
import {
  MainDiv,
  NotesTitle,
  NotesDiv,
  NoteDate,
  Textarea,
  ActionsDiv,
  ActionButtonsDiv,
  CancelButton,
  NewNoteButton,
  DeleteNoteDiv,
  DeleteText,
  BackAndDeleteDiv,
  BackButton,
  DeleteButton,
} from "./styles";
import UseFetch from "../../../../../../config/useFetch";
import Popup from "../../../../../popup";
import ButtonTransparentWithIcon from "../../../../../buttonTransparentWithIcon";
// Assets
import DeleteImg from "../../../../../../assets/icons/btn_delete_user.svg";

const EditNote = ({ setShowEditNote, editNoteData, refreshData, setRefreshData }) => {
  const [noteDate, setNoteDate] = useState(editNoteData.NOTE_CREATION_DATE);
  const [newNote, setNewNote] = useState(editNoteData.NOTE);
  const [newNoteError, setNewNoteError] = useState(false);
  const [showDeleteNotePopup, setShowDeleteNotePopup] = useState(false);

  const { patientId } = useParams();

  useEffect(() => {
    return () => {
      setNoteDate("");
      setNewNote("");
      setNewNoteError(false);
      setShowDeleteNotePopup(false);
    };
  }, []);

  const handleSetNote = (e) => {
    setNewNote(e.target.value);
    setNewNoteError(false);
  };

  const editNote = () => {
    if (!newNote) {
      setNewNoteError(true);
      return toast.error("You must write a note");
    }

    UseFetch("put", `${WEB_SERVICE_MIMS}/recsys/update-note/${patientId}`, new AbortController(), {
      RECSYS_NOTES_ID: editNoteData.RECSYS_NOTES_ID,
      note: newNote,
    })
      .then(({ data }) => {
        if (data.noteUpdated) {
          toast.success("Note updated successfully");
          setShowEditNote(false);
          setRefreshData(!refreshData);
        }
      })
      .catch((error) => {
        console.log("Update note: ", error);
      });
  };

  const deleteNote = () => {
    UseFetch("put", `${WEB_SERVICE_MIMS}/recsys/delete-note/${patientId}`, new AbortController(), {
      RECSYS_NOTES_ID: editNoteData.RECSYS_NOTES_ID,
    })
      .then(({ data }) => {
        if (data.noteDeleted) {
          toast.success("Note deleted successfully");
          setShowEditNote(false);
          setShowDeleteNotePopup(false);
          setRefreshData(!refreshData);
        }
      })
      .catch((error) => {
        console.log("Delete note: ", error);
      });
  };

  const renderDeleteNotePopup = () => {
    return (
      <Popup isShowed={showDeleteNotePopup} setIsShowed={setShowDeleteNotePopup} backgroundId="deleteNotePopup">
        <DeleteNoteDiv>
          <DeleteText>Are you sure you want to delete the note?</DeleteText>
          <BackAndDeleteDiv>
            <BackButton onClick={() => setShowDeleteNotePopup(false)}>{"Back"}</BackButton>
            <DeleteButton onClick={deleteNote}>Delete</DeleteButton>
          </BackAndDeleteDiv>
        </DeleteNoteDiv>
      </Popup>
    );
  };

  return (
    <>
      <MainDiv>
        <NotesTitle>Edit note</NotesTitle>
        <NotesDiv>
          <NoteDate>{noteDate}</NoteDate>
          <Textarea id="noteText" value={newNote} onChange={handleSetNote} placeholder="Write your note here" error={newNoteError} />
        </NotesDiv>
        <ActionsDiv>
          <ButtonTransparentWithIcon icon={DeleteImg} name={"Delete note"} onClick={() => setShowDeleteNotePopup(true)} />
          <ActionButtonsDiv>
            <CancelButton onClick={() => setShowEditNote(false)}>Cancel</CancelButton>
            <NewNoteButton onClick={editNote}>Save</NewNoteButton>
          </ActionButtonsDiv>
        </ActionsDiv>
      </MainDiv>
      {showDeleteNotePopup && renderDeleteNotePopup()}
    </>
  );
};

export default EditNote;
